module.exports = __webpack_public_path__ + "static/Forager1-ad0e078ce841aaace906257c8ae4ecd0.webp";